export function isCopilot(login: string) {
  // need a more dynamic way to check if this is an "Assignable" agent
  const lowercaseLogin = login.toLocaleLowerCase()
  return lowercaseLogin === 'copilot-swe-agent' || lowercaseLogin === 'copilot'
}
